import type { FC } from "react";

import { Button } from "@jti/core-components/components/Button";
import { useDeviceBreakpoint } from "@jti/ui/hooks/useDeviceBreakpoint";

import styles from "./ActionButtons.module.scss";

type ActionButtonsProps = {
  primaryButtonLabel: string;
  secondaryButtonLabel: string;
  onPrimaryButtonClick?: () => void;
  onSecondaryButtonClick?: () => void;
  renderPrimaryButton?: boolean;
  isPrimaryButtonLoading?: boolean;
  isPrimaryButtonDisabled?: boolean;
};

export const ActionButtons: FC<ActionButtonsProps> = ({
  primaryButtonLabel,
  renderPrimaryButton = true,
  isPrimaryButtonLoading = false,
  isPrimaryButtonDisabled = false,
  secondaryButtonLabel,
  onSecondaryButtonClick,
  onPrimaryButtonClick,
}) => {
  const { breakpoint } = useDeviceBreakpoint();
  const isSmallScreen = breakpoint === "mobile";
  return (
    <div className={styles.buttonsWrapper}>
      {renderPrimaryButton && (
        <Button
          size={isSmallScreen ? "sm" : "md"}
          className={styles.button}
          data-testid="primary-button"
          onClick={onPrimaryButtonClick}
          pending={isPrimaryButtonLoading}
          disabled={isPrimaryButtonDisabled}
        >
          {primaryButtonLabel}
        </Button>
      )}
      <Button
        variant="secondary"
        onClick={onSecondaryButtonClick}
        size={isSmallScreen ? "sm" : "md"}
        className={styles.button}
        data-testid="secondary-button"
      >
        {secondaryButtonLabel}
      </Button>
    </div>
  );
};
